import {
  FormControl,
  InputLabel,
  MenuItem,
  Select as MuiSelect,
} from "@mui/material";
import FormHelperText from "@mui/material/FormHelperText";
import React from "react";

function AdministrativeSelect(props) {
  const {
    name,
    label,
    value,
    style = { width: "100%", margin: "" },
    onChange,
    options,
    error,
    optionField = { key: "provinceCode", value: "provinceName" },
    ...other
  } = props;

  const styleDefault = { width: "100%", margin: "10px 0", ...style };
  return (
    <FormControl
      variant="outlined"
      sx={{ ...styleDefault, ...style }}
      error={error ? true : false}
    >
      <InputLabel>{label}</InputLabel>
      <MuiSelect
        label={label}
        name={name}
        value={value}
        onChange={onChange}
        {...other}
      >
        {/* <MenuItem value="">None</MenuItem> */}
        {options.map((option) => (
          <MenuItem
            key={option[optionField.key]}
            value={option[optionField.key]}
          >
            {option[optionField.value]}
          </MenuItem>
        ))}
      </MuiSelect>
      {error && <FormHelperText>This is required!</FormHelperText>}
    </FormControl>
  );
}

export default AdministrativeSelect;
